class AdvDecResponseMappper {
    formatResponse(streamRes, cb) {
        try {
            const ResData = JSON.parse(streamRes).response.data;
            if (ResData) {
                cb({
                    low: ResData.dc,
                    high: ResData.ac,
                    target: ResData.zc,
                    symbol: ResData.sym,
                    lut: ResData.ltt,
                });
            }
        }
        catch (error) { }
    }
}
export default AdvDecResponseMappper;
